import { LOGOS } from "./logoPaths";

var getMichelinLogoPath = function getMichelinLogoPath(props) {
  var logo = LOGOS.commercial[props.direction].whiteBg;
  return logo;
};

export { getMichelinLogoPath };